export default __webpack_public_path__ + "static/media/logo_conectime.536a9e5d.png";